<template>
  <header class="sticky top-0 z-40 bg-bg/95 backdrop-blur border-b-2 border-border">
    <div class="max-w-7xl mx-auto px-4 md:px-8 py-4">
      <div class="flex items-center justify-between">
        <a href="#" class="flex items-center gap-3 group">
          <img
            src="/jiker-logo.png"
            alt="JIKER"
            class="w-9 h-9 border-2 border-border rounded-md transition-transform group-hover:rotate-6"
          >
          <span class="text-xl font-bold">JIKER</span>
        </a>

        <nav class="hidden md:flex items-center gap-8">
          <a
            v-for="item in navItems"
            :key="item.href"
            :href="item.href"
            class="text-text-regular font-medium hover:text-text-primary transition-colors"
          >
            {{ item.label }}
          </a>
        </nav>

        <div class="flex items-center gap-3">
          <LangSwitcher class="hidden md:flex" />
          <a
            href="#products"
            class="btn-brutal btn-brutal-primary text-sm py-2 px-4"
          >
            {{ $t('nav.exploreProducts') }}
          </a>
          <button
            class="md:hidden btn-brutal btn-brutal-ghost p-2"
            aria-label="Toggle menu"
            @click="menuOpen = !menuOpen"
          >
            <svg
              v-if="!menuOpen"
              class="w-5 h-5"
              viewBox="0 0 20 20"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M3 6h14M3 10h14M3 14h14" />
            </svg>
            <svg
              v-else
              class="w-5 h-5"
              viewBox="0 0 20 20"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M15 5L5 15M5 5L15 15" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Mobile menu -->
      <div
        v-if="menuOpen"
        class="md:hidden mt-4 pt-4 border-t-2 border-border"
      >
        <nav class="flex flex-col gap-3">
          <a
            v-for="item in navItems"
            :key="item.href"
            :href="item.href"
            class="text-text-regular font-medium py-2 hover:text-text-primary"
            @click="menuOpen = false"
          >
            {{ item.label }}
          </a>
          <div class="pt-2">
            <LangSwitcher />
          </div>
        </nav>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LangSwitcher from './LangSwitcher.vue';

const { t } = useI18n();
const menuOpen = ref(false);

const navItems = computed(() => [
  { label: t('nav.products'), href: '#products' },
  { label: t('nav.mission'), href: '#mission' },
  { label: t('nav.stories'), href: '#stories' },
  { label: t('nav.contact'), href: '#contact' },
]);
</script>
